import React, { useEffect, useRef, useState, useCallback } from 'react';
import { pageAtom, myNftBackAtom, metaMaskAtom, topMessageAtom } from '../../State';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import * as PIXI from 'pixi.js';
import { Assets } from '@pixi/assets';
import isElectron from '../../Global';
import { useParams, useNavigate } from 'react-router-dom';
import { getImagePath } from '../Util/utils';
import { isMobile } from 'react-device-detect';

export default function BackGround({ pixiRef, canvasRef, canvasWidth, canvasHeight }) {
  const myNftBackState = useRecoilValue(myNftBackAtom);
  const defaultBack = 'whiteYellow.png';
  const logoRef = useRef(null);
  const backRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      loadBack();
    }, 200);
  }, [myNftBackState]);

  async function loadBack() {
    //既に背景が存在する場合は削除
    if (backRef.current != null) {
      //既にある背景を削除
      backRef.current.parent.removeChild(backRef.current);
      backRef.current = null;
    }

    var finalURL;
    if (myNftBackState == null) {
      finalURL = defaultBack;
    } else {
      finalURL = myNftBackState;
    }

    try {
      //finalURL = 'https://d2wp3sepl8g4xv.cloudfront.net/backImages/' + finalURL;

      //カスタム背景の場合
      if (finalURL.startsWith('custom')) {
        let baseURL = 'https://storage.googleapis.com/faceless-97bcf.appspot.com/mybackground/';
        finalURL = baseURL + finalURL;
      } else if (finalURL == 'h4.jpg') {
        finalURL = 'https://faceless.hiho.jp/background/back.png';
      } else {
        finalURL = getImagePath() + '/background/' + finalURL;
      }

      // finalURL = getImagePath() + '/video/test.mp4';

      // if (isElectron) {
      //   finalURL = './images/background/' + finalURL;
      // } else {
      //   finalURL = '../../images/background/' + finalURL;
      // }

      let texture;

      //拡張子
      let fileType = finalURL.split('.').pop();

      //動画の場合
      if (fileType == 'mp4') {
        texture = PIXI.Texture.from(finalURL);
        texture.baseTexture.resource.source.loop = true;
      }
      //その他画像の場合
      else {
        try {
          texture = await Assets.load(finalURL);
        } catch (e) {
          console.log(e);
        }
      }

      // backRef.current = new PIXI.Sprite.from(finalURL, {
      //   resourceOptions: {
      //     autoPlay: true,
      //     updateFPS: 30,
      //     loop: true,
      //   },
      // });

      backRef.current = new PIXI.Sprite(texture);
      pixiRef.current.stage.addChild(backRef.current);
      // backRef.current.scale.set();
      backRef.current.anchor.set(0.5, 0.5);

      //ソート順序を変更
      backRef.current.zIndex = -2;

      //位置の調整
      adjustBack();
    } catch (error) {
      console.log('エラー');
      console.log(error);
    }
    //});

    // loader.onError((e) => {
    //   console.log('エラー');
    //   console.log(e);
    // });
  }

  useEffect(() => {
    if (isMobile) return;
    initLogo();
  }, []);

  //リサイズ時
  useEffect(() => {
    //ロゴを追加
    if (logoRef.current != null) {
      setTimeout(() => {
        adjustLogo();
      }, 100);
    }

    //背景の位置調整
    if (backRef.current != null) {
      setTimeout(() => {
        adjustBack();
      }, 100);
    }
  }, [canvasWidth, canvasHeight]);

  //ロゴを作成
  async function initLogo() {
    // const loader = new PIXI.Loader();
    //loader.add('logo', './images/header/logoPng.png');

    let loadURL = getImagePath() + '/header/logoPng.png';

    const texture = await Assets.load(loadURL);
    // loader.load((_, resources) => {
    logoRef.current = new PIXI.Sprite(texture);
    pixiRef.current.stage.addChild(logoRef.current);
    logoRef.current.anchor.set(0, 0);

    //ソート順序を変更
    logoRef.current.zIndex = 1;

    //マイスポインター
    logoRef.current.interactive = true;
    logoRef.current.buttonMode = true;

    //ジェスチャー追加
    logoRef.current.click = function () {
      onClick();
    };

    //位置の調整
    adjustLogo();
    //  });
  }

  //クリック処理
  function onClick() {
    if (isElectron) {
      window.myapi.closeWindow();
    } else {
      //navigate('/');
      window.location.href = 'https://faceless.ooo';
    }
  }

  function adjustLogo() {
    let logoWidth = logoRef.current.width;
    let logoHeight = logoRef.current.height;

    logoRef.current.width = 100;
    logoRef.current.height = 30;
    logoRef.current.position.set(0, 0);

    // let finalWidth;
    // finalWidth = canvasRef.current?.offsetHeight * 0.3;
    // logoRef.current.width = finalWidth;
    // logoRef.current.height = (logoHeight * finalWidth) / logoWidth;

    // logoRef.current.position.set(
    //   canvasRef.current?.offsetWidth / 2,
    //   canvasRef.current?.offsetHeight * 0.17,
    // );
  }

  //位置の調整
  function adjustBack() {
    let backWidth = backRef.current.width;
    let backHeight = backRef.current.height;

    if (backHeight == 1 && backWidth == 1) {
      setTimeout(() => {
        adjustBack();
      }, 1000);
    }

    var finalWidth;
    var finalHeight;

    if (backWidth >= backHeight) {
      finalHeight = canvasRef.current?.offsetHeight;
      finalWidth = (backWidth * canvasRef.current?.offsetHeight) / backHeight;

      if (finalWidth <= canvasRef.current?.offsetWidth) {
        finalWidth = canvasRef.current?.offsetWidth;
        finalHeight = (backHeight * canvasRef.current?.offsetWidth) / backWidth;
      }
    } else if (backWidth < backHeight) {
      finalWidth = canvasRef.current?.offsetWidth;
      finalHeight = (backHeight * canvasRef.current?.offsetWidth) / backWidth;

      if (finalHeight <= canvasRef.current?.offsetHeight) {
        finalHeight = canvasRef.current?.offsetHeight;
        finalWidth = (backWidth * canvasRef.current?.offsetHeight) / backHeight;
      }
    }

    backRef.current.width = finalWidth;
    backRef.current.height = finalHeight;

    backRef.current.position.set(
      canvasRef.current?.offsetWidth / 2,
      canvasRef.current?.offsetHeight / 2,
    );
  }

  return false;

  // return (
  //   <>
  //     <div
  //       id="backgroundDummy"
  //       style={{
  //         backgroundImage: 'url(' + finalURL + ')',
  //       }}></div>
  //   </>
  // );
}
